import { FaEye, FaEyeSlash } from "react-icons/fa6";

import { Container, Label, WrapperInput, Input } from "./styles";

function Inputs(props) {
  return (
    <Container width={props.width} style={props.style}>
      <Label error={props.error} backgroundLabel={props.backgroundLabel}>
        {props.label}
      </Label>

      <WrapperInput>
        <Input placeholder={props.error ? props.error : ""} error={props.error} {...props} />

        {props.password && (
          <div className="iconViewPass" onClick={props.onClickPassword} style={{ zIndex: 10 }}>
            {props.showPassword ? (
              <FaEye size={18} color={"#222"} fill={"#222"} />
            ) : (
              <FaEyeSlash size={18} color={"#222"} fill={"#222"} />
            )}
          </div>
        )}
      </WrapperInput>
    </Container>
  );
}

export default Inputs;
